module.exports = __webpack_public_path__ + "static/media/logo.f582b41d.jpg";